import axios from 'axios'
import _ from 'lodash'
import store from '../store'

export default () => {

  const apiDomain = _.get(store.state, 'props.apiDomain', 'https://api.gofundraise.com') 

  return {
    /**
     * Get beneficiaries from API using custom query params
     */
    async searchWithParams(params) {
      if (params) {
        params.region = _.get(store.state, 'props.region') 
          ? store.state.props.region.toUpperCase()
          : ''
      }

      return await axios.get(apiDomain + '/v1/beneficiaries/search', {
        params: params
      })
    },

    /**
     * Get beneficiaries from API for a specific event
     */
    async searchByEvent(eventCampaignId, tags, includeInactiveBeneficiaries = false) {
      var params = {
        eventcampaignid: eventCampaignId,
        includeinactivebeneficiaries: includeInactiveBeneficiaries
      }

      if (tags && tags.length > 0)
        params.tags = tags
      return await this.searchWithParams(params)
    },

    /**
     * Get beneficiary details by Id
     */
    async getBeneficiaryById(beneficiaryId) {
      return await this.searchWithParams({
        beneficiaryid: beneficiaryId
      })
    },

    /**
     * get beneficiary for tiers
    */
    async getbeneficiaryForTiers(query, maxResultsToDisplay) {
      query.pagesize = maxResultsToDisplay
      query.pageindex = 1

      return await this.searchWithParams(query)
    },
  }
}
